import * as React from "react";
import Box from "@mui/material/Box";
import Alert from "@mui/material/Alert";
import IconButton from "@mui/material/IconButton";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import CloseIcon from "@mui/icons-material/Close";

type MessageProps = {
  message?: string;
};
export default function NotificationBar(props: MessageProps) {
  const [open, setOpen] = React.useState(true);

  return (
    <>
    {props.message ? (
    <Box sx={{ width: "100%" }}>
      <Collapse in={open}>
        <Alert
          icon={false}
         
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
                setOpen(false);
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
          sx={{ mb: 2 ,backgroundColor:"#DFF0D8",color:"#6E9F71" ,fontWeight:510}}
        >
          {props.message}
        </Alert>
      </Collapse>
      {/* <Button
        disabled={open}
        variant="outlined"
        onClick={() => {
          setOpen(true);
        }}
      >
        Re-open
      </Button> */}
    </Box>
  ) : null }
  </>
  );
}
